import { useMemo } from "react";
import { statementsInOrder, statementText } from "../statements/statementKinds";
import { useTaskLinkLists } from "./TaskLinksContext";

// The dreams and fears a task can be for, as the task editor lists them: dreams in the Dreamboard's order, fears
// category by category. Each is `{ loaded, options: [{ id, label }] }`; `loaded` is false while loading and if the
// list couldn't load (see keptLink).
export function useTaskLinkChoices(categories) {
  const { dreams, fears } = useTaskLinkLists();
  const dreamOptions = useMemo(() => dreams.items.map(d => ({ id: d.id, label: d.title })), [dreams.items]);
  const fearOptions = useMemo(() => statementsInOrder("fears", fears.items, categories)
    .map(f => ({ id: f.id, label: statementText("fears", f) })), [fears.items, categories]);
  return {
    dreams: { loaded: !dreams.loading && !dreams.error, options: dreamOptions },
    fears: { loaded: !fears.loading && !fears.error, options: fearOptions },
  };
}
